const { CALCULATOR, CONSTANTS } = require('../config')
const { currency, number, rate, size } = require('../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {string|null} locale
 * @param {object|null} disclaimerValues
 * @param {string|null} disclaimerText
 * @returns {*}
 */
function setRefinanceDisclaimer ({ country, locale = null, disclaimerValues = null, disclaimerText = null } = {}) {
  if (!country) return ''

  const constants = CONSTANTS[country?.toUpperCase()]
  const calculator = CALCULATOR[country?.toUpperCase()]
  const text = disclaimerText || calculator.DISCLAIMER?.[locale || constants.LOCALE]

  const values = disclaimerValues || calculator.DEFAULT_VALUES_REFINANCE
  if (!size(values) || !size(text)) return ''

  return text
    .toString()
    .replace(/{amount}/g, currency(values.amount ?? calculator.DEFAULT_VALUES_REFINANCE.amount, country, locale, 0))
    .replace(/{minAmount}/g, currency(values.minAmount ?? constants.LOAN_AMOUNT_REFINANCE.MIN, country, locale, 0))
    .replace(/{maxAmount}/g, currency(values.maxAmount ?? constants.LOAN_AMOUNT_REFINANCE.MAX, country, locale, 0))
    .replace(/{duration}/g, number(values.duration ?? calculator.DEFAULT_VALUES_REFINANCE.duration, country, locale, 0))
    .replace(/{occasions}/g, number(values.occasions ?? calculator.DEFAULT_VALUES_REFINANCE.occasions, country, locale, 0))
    .replace(/{minDuration}/g, number(values.minDuration ?? constants.DURATION_REFINANCE.MIN, country, locale, 0))
    .replace(/{maxDuration}/g, number(values.maxDuration ?? constants.DURATION_REFINANCE.MAX, country, locale, 0))
    .replace(/{interest}/g, rate(values.interest ?? calculator.DEFAULT_VALUES_REFINANCE.interest, country, locale, 2))
    .replace(/{effectiveInterest}/g, rate(values.effectiveInterest ?? calculator.DEFAULT_VALUES_REFINANCE.effectiveInterest, country, locale, 2))
    .replace(/{cost}/g, currency(values.cost ?? calculator.DEFAULT_VALUES_REFINANCE.cost, country, locale, 0))
    .replace(/{totalCost}/g, currency(values.totalCost ?? calculator.DEFAULT_VALUES_REFINANCE.totalCost, country, locale, 0))
    .replace(/{monthlyCost}/g, currency(values.monthlyCost ?? calculator.DEFAULT_VALUES_REFINANCE.monthlyCost, country, locale, 0))
    .replace(/{installmentMonths}/g, number(values.installmentMonths ?? calculator.DEFAULT_VALUES_REFINANCE.installmentMonths, country, locale, 0))
    .replace(/{startupFee}/g, currency(values.startupFee ?? calculator.DEFAULT_VALUES_REFINANCE.startupFee, country, locale, 0))
    .replace(/{monthlyFee}/g, currency(values.monthlyFee ?? calculator.DEFAULT_VALUES_REFINANCE.monthlyFee, country, locale, 0))
    .replace(/{date}/g, values.date ?? calculator.DEFAULT_VALUES_REFINANCE.date)
    .replace('undefined', '')
    .replace('null', '')
}

module.exports = { setRefinanceDisclaimer }
